export var suppliersData=[
      {
        id:1,
        name:'中粮集团有限公司',
        products:"玉米，小麦，淀粉",
        created_at:'2020-11-30 14:38',
        user:'张三',
      },
      {
        id:2,
        name:'中国石化',
        products:"柴油，汽油，煤油",
        created_at:'2020-10-30 14:38',
        user:'李四',
      },
      {
        id:3,
        name:'黑龙江黑土地',
        is_published:'已发布',
        amount:205396,
        percent:'30%',
        created_at:'2020-9-28 8:26'
      },
      {
        id:4,
        contract_no:'DX19LR10',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-8-28 8:26'
      },
      {
        id:5,
        contract_no:'DX19LR09',
        name:'DragIt Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:6,
        contract_no:'DX19LR11',
        name:'Drag Laravel Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:7,
        contract_no:'DX19LR11',
        name:'Drag C# Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:8,
        contract_no:'DX19LR11',
        name:'Drag Java Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:9,
        contract_no:'DX19LR11',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:10,
        contract_no:'DX19LR11',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:11,
        contract_no:'DX19LR11',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:12,
        contract_no:'DX19LR11',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:13,
        contract_no:'DX19LR11',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:14,
        contract_no:'DX19LR11',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
      {
        id:15,
        contract_no:'DX19LR11',
        name:'DragRx Tech Co.,Ltd.',
        amount:205396,
        percent:'100%',
        commission:'101020',
        created_at:'2020-9-28 8:26'
      },
    ]